/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { rfpDraftsControllerRfp } from "./rfpDraftsControllerRfp";
import { rfpDraftsControllerStartRfp } from "./rfpDraftsControllerStartRfp";

export function rfpDraftsService() {
  return { rfpDraftsControllerRfp, rfpDraftsControllerStartRfp }
}